const handleLocationHash = (hash: string) => {
    if (hash) {
        return decodeURIComponent(hash.split('=')[1]);
    }
    return null;
};

export default handleLocationHash;
